import { FillPaint } from 'mapbox-gl';

export const floodMapPaintConfig: FillPaint = {
  'fill-pattern': [
    'case',
    ['==', ['get', 'zonetype'], 'A'],
    'a-legend',
    ['all', ['==', ['get', 'zonesubtyp'], 'FLOODWAY'], ['==', ['get', 'zonetype'], 'AE']],
    'ae-regulatory-legend',
    ['all', ['!=', ['get', 'zonesubtyp'], 'FLOODWAY'], ['==', ['get', 'zonetype'], 'AE']],
    'ae-legend',
    ['==', ['get', 'zonetype'], 'AH'],
    'ah-legend',
    ['==', ['get', 'zonetype'], 'AO'],
    'ao-legend',
    ['==', ['get', 'zonetype'], 'VE'],
    've-legend',
    ['==', ['get', 'zonetype'], 'D'],
    'd-legend',
    [
      'all',
      ['==', ['get', 'zonesubtyp'], 'AREA WITH REDUCED FLOOD RISK DUE TO LEVEE'],
      ['==', ['get', 'zonetype'], 'X'],
    ],
    'x-reduced-legend',
    [
      'all',
      ['==', ['get', 'zonesubtyp'], '1 PCT DRAINAGE AREA LESS THAN 1 SQUARE MILE'], // TODO: CONFIRM
      ['==', ['get', 'zonetype'], 'X'],
    ],
    'x-drainage-legend',
    [
      'all',
      ['!=', ['get', 'zonesubtyp'], '1 PCT DRAINAGE AREA LESS THAN 1 SQUARE MILE'], // TODO: CONFIRM
      ['!=', ['get', 'zonesubtyp'], 'AREA WITH REDUCED FLOOD RISK DUE TO LEVEE'],
      ['==', ['get', 'zonetype'], 'X'],
    ],
    'x-legend',
    ['==', ['get', 'zonetype'], 'AREA NOT INCLUDED'],
    'not-included-legend',
    'white',
  ],
  'fill-opacity': 0.4,
  'fill-outline-color': 'white',
};
